module.exports = __webpack_public_path__ + "img/dot.3d5adba4.svg";